import { useQuery } from "@tanstack/react-query";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { get } from "common/helpers/HTTP";

import type {
  AgencyPlan,
  AppSumoPromotion,
  LTDPromotion,
  Promotion,
} from "../types";

async function getPromotionsRequest(): Promise<Promotion[]> {
  return (await get(`customers/promotions`)).promotions;
}

export default function usePromotions() {
  const { data: promotions, isLoading: isLoadingPromotions } = useQuery({
    queryKey: CUSTOMER_QUERY_KEYS.promotions,
    queryFn: () => getPromotionsRequest(),
  });

  const ltdPromotion = promotions?.find(
    ({ type }) => type === "ltd",
  ) as LTDPromotion;
  const appSumoPromotion = promotions?.find(
    ({ type }) => type === "appsumo",
  ) as AppSumoPromotion;
  const agencyPlan = promotions?.find(
    ({ type }) => type === "agency",
  ) as AgencyPlan;

  // Lifetime seats can come from either pool, so total availability must
  // sum both rather than only looking at whichever one is found first.
  const lifetimeUnassignedLicenseCount =
    (ltdPromotion?.unassigned_license_count ?? 0) +
    (appSumoPromotion?.unassigned_license_count ?? 0);

  return {
    ltdPromotion,
    appSumoPromotion,
    agencyPlan,
    isLoadingPromotions,
    lifetimeUnassignedLicenseCount,
  };
}
